import type { TokenStorage } from "./token-storage";

export const tokenStorage: TokenStorage = {
  getToken: async (key) => localStorage.getItem(key) || null,
  removeToken: async (key) => localStorage.removeItem(key),
  setToken: async (key, token) => localStorage.setItem(key, token),
};
